export default {
  isPricesDealerEdit(state, getters) {
    return state.prices.dealer?.is_edit ?? false;
  },
}
